export default __webpack_public_path__ + "static/media/2.3b7ed862.mp4";